import { Link } from '@tanstack/react-router'

interface OverviewViewLinkProps {
  to: string
}

export const OverviewViewLink = ({ to }: OverviewViewLinkProps) => (
  <Link
    to={to}
    className="cursor-pointer text-sm font-medium text-ink-subtle hover:text-blue-7"
  >
    View
  </Link>
)
